<template>
    <div>
        <v-card class="pa-3 ma-3">
            <v-card-title>
                <v-toolbar flat color="#1d2735" dark>
                    <pre><v-toolbar-title><h2>Lista de albaranes de venta</h2></v-toolbar-title></pre>
                </v-toolbar>
            </v-card-title>

            <v-card-text>
                <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            to="guardar-albaran-venta"
                            color="warning"
                            class="mt-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon class="white--text">mdi-plus</v-icon>
                        </v-btn>
                    </template>
                    <span>Nuevo albarán de venta</span>
                </v-tooltip>

                <v-row>
                    <v-col cols="12" md="8">
                        <filter-component-vue
                            :headers="filter_headers"
                            v-model="filters"
                        ></filter-component-vue>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-btn
                            color="primary"
                            class="white--text"
                            @click="
                                () => {
                                    page = 1;
                                    getData();
                                }
                            "
                        >
                            Filtrar
                        </v-btn>
                        <v-btn
                            color="red"
                            class="white--text"
                            @click="
                                filters = {};
                                getData();
                            "
                        >
                            Limpiar filtros
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <v-data-table
                            :headers="headers"
                            :items="data"
                            item-key="id"
                            class="elevation-1 pointer"
                            @click:row="handleClick"
                            :options.sync="options"
                            @update:options="onOptionsUpdate"
                            :server-items-length="totalData"
                            :loading="loading"
                        >
                            <template v-slot:item.pdf="{ item }">
                                <a
                                    target="blank"
                                    :href="`api/albaran/venta/pdf/${item.id}`"
                                >
                                    <v-icon
                                        small
                                        class="mr-2"
                                        color="red"
                                        style="font-size: 25px"
                                        title="PDF"
                                    >
                                        mdi-pdf-box
                                    </v-icon>
                                </a>
                            </template>
                            <template v-slot:item.importe="{ item }">
                                {{ formatPrice(item.importe) }}€
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <a @click.stop="openModal(item.id)">
                                    <v-icon
                                        small
                                        class="mr-2"
                                        color="red"
                                        style="font-size: 25px"
                                        title="BORRAR"
                                    >
                                        mdi-trash-can
                                    </v-icon>
                                </a>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <DeleteDialogVue v-model="dialog" :id="id_item" @delete="deleteData" />
    </div>
</template>
<script>
import FilterComponentVue from "../../../components/general/FilterComponent.vue";
import DeleteDialogVue from "./DeleteDialog.vue";
import { formatPrice } from "../../../helpers";

export default {
    components: { FilterComponentVue, DeleteDialogVue },
    data() {
        return {
            loading: false,
            headers: [
                {
                    text: "Nº Albarán",
                    value: "nro",
                    sortable: true,
                    align: "center",
                },
                {
                    text: "Nombre de cliente",
                    value: "nombre_cliente",
                    sortable: true,
                },
                {
                    text: "Fecha",
                    value: "fecha",
                    sortable: true,
                    align: "center",
                },
                {
                    text: "Importe",
                    value: "importe",
                    align: "center",
                    sortable: true,
                },
                { text: "PDF", value: "pdf", align: "center", sortable: false },
                {
                    text: "Acciones",
                    value: "actions",
                    sortable: false,
                    align: "center",
                },
            ],
            data: [],
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: [],
            },
            totalData: 0,
            filter_headers: [
                // {
                //     title: "Fecha",
                //     type: "date",
                //     active: false,
                //     model: "fecha",
                // },
                {
                    title: "Cliente",
                    type: "cliente",
                    active: false,
                    model: "id_cliente",
                },
            ],
            filters: {},
            dialog: false,
            id_item: null,
        };
    },
    created() {
        //
    },
    methods: {
        getData() {
            this.loading = true;
            axios
                .get("api/albaran/venta", {
                    params: {
                        page: this.options.page,
                        rowsPerPage: this.options.itemsPerPage,
                        sort_by: this.options.sortBy.join(","),
                        sort_desc: this.options.sortDesc.join(","),
                        ...this.filtersParams,
                    },
                })
                .then((res) => {
                    const response = res.data.success;
                    this.data = response.data;
                    this.totalData = response.total;
                    this.loading = false;
                })
                .catch((error) => {
                    console.log("error", error);
                    this.$toast.error(error);
                });
        },
        deleteData(id) {
            axios
                .delete(`api/albaran/venta/${id}`)
                .then((res) => {
                    this.$toast.success(res.data.success);
                    this.getData();
                    this.dialog = false;
                })
                .catch((error) => {
                    this.$toast.error(error);
                });
        },
        handleClick(value) {
            this.$router.push(`/guardar-albaran-venta?id=${value.id}`);
        },
        onOptionsUpdate(newOptions) {
            this.options = newOptions;
            this.getData();
        },
        openModal(id) {
            this.id_item = id;
            this.dialog = true;
        },

        formatPrice,
    },
    computed: {
        filtersParams() {
            let params = {};

            if (this.filters.search) {
                params.search = this.filters.search;
            }

            this.filter_headers.forEach((head) => {
                if (this.filters[head.model]) {
                    if (head.type == "date") {
                        if (this.filters[head.model].start) {
                            params[`${head.model}_desde`] =
                                this.filters[head.model].start;
                        }
                        if (this.filters[head.model].end) {
                            params[`${head.model}_hasta`] =
                                this.filters[head.model].end;
                        }
                    } else if (
                        this.filters[head.model].value ||
                        this.filters[head.model].nombre
                    ) {
                        params[head.model] =
                            this.filters[head.model].value ||
                            this.filters[head.model].nombre;
                    }
                }
            });

            return params;
        },
    },
    watch: {
        //
    },
};
</script>
